import { Area } from './area-model';

export class AreaMap {
    areas: Area[];
}
